module.exports = __webpack_public_path__ + "static/media/bg-cnito-games-tablet.eddc2f1e.png";